import React from "react";
import Loadable from "react-loadable";

const MyLoadingComponent = ({ isLoading, error }) => {
  // Handle the loading state
  if (isLoading) {
    return <div>Loading...</div>;
  }
  // Handle the error state
  else if (error) {
    return (
      <div>متاسفانه در نمایش این صفحه مشکلی بوجود آمده است .منتظر بمانید.</div>
    );
  } else {
    return null;
  }
};

export const Routers = [
  {
    component: Loadable({
      loader: () => import("../views/home"),
      loading: MyLoadingComponent
    }),
    link: "/",
    public: true
  },
  {
    component: Loadable({
      loader: () => import("../views/userProfile"),
      loading: MyLoadingComponent
    }),
    link: "/profile",
    public: false
  },
  {
    component: Loadable({
      loader: () => import("../views/search"),
      loading: MyLoadingComponent
    }),
    link: "/search",
    public: true
  },
  {
    component: Loadable({
      loader: () => import("../views/Product"),
      loading: MyLoadingComponent
    }),
    link: "/product",
    public: true
  },
  {
    component: Loadable({
      loader: () => import("../views/cart"),
      loading: MyLoadingComponent
    }),
    link: "/cart",
    public: false
  },
  {
    component: Loadable({
      loader: () => import("../views/content"),
      loading: MyLoadingComponent
    }),
    link: "/content",
    public: true
  },
  {
    component: Loadable({
      loader: () => import("../views/about"),
      loading: MyLoadingComponent
    }),
    link: "/about",
    public: true
  },
  {
    component: Loadable({
      loader: () => import("../views/test"),
      loading: MyLoadingComponent
    }),
    link: "/test",
    public: true
  },
  {
    component: Loadable({
      loader: () => import("../views/login"),
      loading: MyLoadingComponent
    }),
    link: "/login",
    public: true
  }
];
